export const track = (name, params = {}) => {
  if (typeof window.gtag === "function") window.gtag("event", name, params);
};

export const trackPageView = (path) => {
  setTimeout(() => track("page_view", { page_path: path, page_location: window.location.href, page_title: document.title }), 0);
};
